export default __webpack_public_path__ + "1x-banner-2.jpg";